export default "__VITE_ASSET__n6A4TLEi__"